/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_b2b_order_detailViewProps } from './aaa_b2b_order_detail';
import { IImageSettings, Image } from '@msdyn365-commerce/core';
import { Button } from '@msdyn365-commerce-modules/utilities';
import Toaster from '../order-requestlines-template/components/toaster';
import { getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';

export default (props: IAaa_b2b_order_detailViewProps) => {
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            lg: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            xl: { q: 'w=100&h=100&m=6', w: 100, h: 100 }
        },
        lazyload: true,
        cropFocalRegion: true
    };
    const rounded = (ringSize?: number) => {
        if (ringSize) {
            return ringSize.toFixed(2);
        }
        return '';
    };
    const getProductLink = (line: any) => {
        const productUrl = getProductUrlSync(line.product.ProductDetails, props.context.actionContext, undefined);
        return (
            productUrl +
            (productUrl.indexOf('?') === -1
                ? `?requestOrderId=${line.orderNumber}&lineId=${line.lineNum}`
                : `&requestOrderId=${line.orderNumber}&lineId=${line.lineNum}`)
        );
    };
    return (
        <>
            {!props.isLoading ? (
                <div className={'row aaa-cart-wrapper'}>
                    {props.removePopUp && props.removePopUp.visible && props._renderPopUp()}
                    <div className={'col-auto col-sm-auto col-md-10 col-lg-10 aaa-order-history-detail'}>
                        <>
                            <div className={'aaa-cart-left-section'}>
                                <div className={'col-auto col-sm-auto col-md-3 col-lg-3'}>
                                    <Image
                                        requestContext={props.context.actionContext.requestContext}
                                        altText={props.requestOrderDetail.productName}
                                        className='ms-wishlist-items__product-image'
                                        title={props.requestOrderDetail.imageUrl}
                                        src={props.requestOrderDetail.imageUrl}
                                        fallBackSrc={props.requestOrderDetail.fallbackImage}
                                        gridSettings={props.context.request.gridSettings!}
                                        imageSettings={defaultImageSettings}
                                        loadFailureBehavior={'empty'}
                                    />
                                </div>
                                <div className={'col-auto col-sm-auto col-md-9 col-lg-9 aaa-cart-detail'}>
                                    <div className={'aaa-cart-heading'}>
                                        <span>{props.requestOrderDetail.productName}</span>{' '}
                                        <span>
                                            <Button
                                                className='ms-wishlist-items__product-add-button'
                                                title={'Add To Cart'}
                                                disabled={props.requestOrderDetail.orderExistInCart}
                                                onClick={() => props.addItemToCart(props.requestOrderDetail)}
                                            >
                                                {'Add To Cart'}
                                            </Button>
                                            <a href={getProductLink(props.requestOrderDetail)}>
                                                {' '}
                                                <Button
                                                    className='ms-wishlist-items__product-add-button'
                                                    title={'Customise'}
                                                    disabled={props.requestOrderDetail.orderExistInCart}
                                                >
                                                    {'Customise'}
                                                </Button>
                                            </a>
                                        </span>
                                    </div>
                                    <div className={'aaa-cart-row'}>
                                        <span className={'aaa-cart-row-column'}>
                                            <span className={'aaa-cart-row-column-heading'}>Customer</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.stockistInfo.name}
                                                <br />
                                                {props.requestOrderDetail.stockistInfo.phoneNumber}
                                                <br />
                                                {props.requestOrderDetail.stockistInfo.email}
                                            </span>
                                        </span>
                                    </div>
                                    {props.requestOrderDetail.rings &&
                                        props.requestOrderDetail.rings.map((ring: any) => {
                                            return (
                                                <>
                                                    <div className={'aaa-cart-row margin-0'} key={ring.name} style={{ borderBottom: 0 }}>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{ring.name}</span>
                                                            <span className={'aaa-cart-row-column-text'}>{ring.alloy}</span>
                                                        </span>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Engraving Font'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>{ring.engravingFont}</span>
                                                        </span>
                                                    </div>
                                                    <div
                                                        className={'aaa-cart-row margin-0'}
                                                        key={`Size ${ring.name}`}
                                                        style={{ borderBottom: 0 }}
                                                    >
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Size'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>
                                                                Size {ring.sizeLabel} ( &Oslash; {rounded(ring.sizeValue)}mm)
                                                            </span>
                                                        </span>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Engraving Copy'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>{ring.engravingCopy}</span>
                                                        </span>
                                                    </div>
                                                    <div className={'aaa-cart-row'} key={`Size ${ring.name}`}>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Specification'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>{ring.specifications}</span>
                                                        </span>
                                                        <span className={'aaa-cart-row-column'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{'Reference Number'}</span>
                                                            <span className={'aaa-cart-row-column-text'}>
                                                                {props.requestOrderDetail.referenceNumber}
                                                            </span>
                                                        </span>
                                                        <span className={'aaa-cart-row-column individual-price-content'}>
                                                            <span className={'aaa-cart-row-column-heading'}>{''}</span>
                                                            <span className={'aaa-cart-row-column-text individual-price'}>
                                                                ${ring.price}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </>
                                            );
                                        })}
                                    <div className={'aaa-cart-final-price'}>
                                        <span className={'aaa-cart-total-label'}>Total incl. GST</span>$
                                        {props.requestOrderDetail.totalPrice}
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            ) : !props.isLoading ? (
                <div className={'row aaa-cart-wrapper'}>
                    <div className='col-auto col-sm-auto col-md-12 col-lg-12 ms-order-history__empty-message-container'>
                        <p className='ms-order-history__empty-message'>{'You currently do not have any order detail to view.'}</p>
                    </div>
                </div>
            ) : (
                <div className={'row aaa-cart-wrapper'}>Loading...</div>
            )}
            {props.toasterInfo && props.toasterInfo.visible && (
                <Toaster type={props.toasterInfo.type} message={props.toasterInfo.message} />
            )}
        </>
    );
};
